export default __webpack_public_path__ + "static/media/micro-bocina.a7110e8c.png";